import React, { useState, useEffect } from 'react';
import i18next from 'i18next';

import { DashboardService } from '../../services';

import OriginalDashboard from './original_dashboard';
import { NeedsAttentionDashboardView } from './NeedsAttention';
import { LegacyNeedsAttentionDashboardView } from './LegacyNeedsAttention';

const DashboardDetail = ({initialDashboard}) => {
  if (initialDashboard.uiClass === 'NeedsAttentionDashboardView') {
    return <NeedsAttentionDashboardView />
  } else if (initialDashboard.uiClass === 'LegacyNeedsAttentionDashboardView') {
    return <LegacyNeedsAttentionDashboardView />
  } else {
    return <OriginalDashboard />
  }
}

const Dashboard = () => {
  const [availableDashboards, setAvailableDashboards] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    DashboardService.getAvailableDashboards().then((dashboards) => {
      if (dashboards.data != null && dashboards.data.length > 0) {
        setAvailableDashboards(dashboards.data);
      } else {
        setErrorMessage('No dashboards assigned, please contact OpSense help to assign a dashboard.');
      }
    }).catch((error) => {
      setErrorMessage(`${error}`);
    });
  }, []);

  // TODO if multiple dashboards then show first one and allow for dropdown

  return (
    <div>
      { errorMessage && <div>{errorMessage}</div> }
      { availableDashboards && availableDashboards.length > 0 ? <DashboardDetail initialDashboard={availableDashboards[0]} /> : <div className="loader">{i18next.t('loading')}</div> }
    </div>
  );
}

export default Dashboard;
